import { AttributeDefinition, serializeAttributeDefinition } from 'domain/experiment/attribute';

export function uniqAttributeDefinitions(
  prefillAttributes: AttributeDefinition[],
  attributes: AttributeDefinition[],
): AttributeDefinition[] {
  if (!prefillAttributes.length) {
    return attributes;
  }

  const unique: AttributeDefinition[] = [];
  const seen = new Set<string>();

  for (const attribute of [...prefillAttributes, ...attributes]) {
    const key = serializeAttributeDefinition(attribute);

    if (seen.has(key)) {
      continue;
    }

    seen.add(key);
    unique.push(attribute);
  }

  return unique;
}
